<template lang="pug">
.delete-button-container.no-select(@mousedown="startCounter" @mouseup="restartCounter" @mouseleave="restartCounter")
  .text-delete-instructions(v-if="interval") Press for {{ seconds - secondsPressed + 1 }} seconds to delete
  a.delete-icon-container
    .delete-text Delete
    .delete-icon.times-icon.mini-button
</template>

<script>
import mHoldDown from '@/mixins/holdDown'

export default {
  name: 'DeleteButton',

  mixins: [mHoldDown],

  data () {
    return {
      seconds: 2
    }
  },

  methods: {
    onCounterFinish () {
      this.restartCounter()
      this.$emit('delete')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/DeleteButton.vue